import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get as getCookie } from 'js-cookie';
import styled, { css } from 'styled-components';
import { updateItem } from 'ducks/cart';
import { Button } from 'components/shared';
import guestCartCookieName from 'helpers/guestCartCookieName';
import QuantitySelector from './QuantitySelector';

const Wrapper = styled.div`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 84%;
  background-color: rgba(255, 255, 255, 0.7);
  justify-content: space-around;
  align-items: center;
  ${props =>
    css`
      display: ${props.isVisible ? 'flex' : 'none'};
    `};
`;

class QuantityForm extends React.Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      id: PropTypes.integer,
      quantity: PropTypes.integer,
    }).isRequired,
    isVisible: PropTypes.bool.isRequired,
    updateCartItem: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      quantity: props.cartItem.quantity,
      isSuccess: false,
      isLoading: false,
      changed: false,
    };
    this.onUpdateCartItem = this.onUpdateCartItem.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      quantity: newProps.cartItem.quantity,
      isSuccess: false,
      isLoading: false,
      changed: false,
    });
  }

  async onUpdateCartItem() {
    const cartId = getCookie(guestCartCookieName);
    const { quantity } = this.state;
    this.setState({ isLoading: true });
    await this.props.updateCartItem(cartId, {
      id: this.props.cartItem.id,
      quantity,
    });
    this.setState({ isSuccess: true, isLoading: false });
    this.props.onClick();
  }

  render() {
    const { cartItem } = this.props;
    const { isSuccess, isLoading, quantity, changed } = this.state;

    if (cartItem.sellableType !== 'Product') return null;
    return (
      <Wrapper isVisible={this.props.isVisible}>
        <span>
          <QuantitySelector
            quantity={quantity}
            onChange={change =>
              this.setState({ quantity: quantity + change, changed: true })
            }
          />
        </span>
        <Button
          block
          grey={!changed}
          blue={changed}
          small
          green={isSuccess}
          disabled={isSuccess}
          isLoading={isLoading}
          onClick={this.onUpdateCartItem}
        >
          {isSuccess && 'Updated'}
          {!isLoading && !isSuccess && (changed ? 'Update' : 'Cancel')}
        </Button>
      </Wrapper>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  updateCartItem: updateItem,
};
export default connect(mapStateToProps, mapDispatchToProps)(QuantityForm);



// WEBPACK FOOTER //
// ./src/components/shared/CartDrawer/components/QuantityForm.jsx